var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.dataLoading)?_c('SplashScreen'):(_vm.dataError)?_c('DataNotLoaded'):_c('div',{staticClass:"h-100 w-100 flex-grow-1"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }